import { uploadFile } from '@/api/upload'
import { normalizeFileUrl, resolveFileUrl } from '@/utils/fileUrl'

export const EDITOR_LIMITS = {
  image: 2 * 1024 * 1024,
  video: 500 * 1024 * 1024,
  attachment: 20 * 1024 * 1024
}

export function formatFileSize(size) {
  if (size >= 1024 * 1024) {
    return `${(size / (1024 * 1024)).toFixed(0)}MB`
  }
  return `${Math.max(1, Math.round(size / 1024))}KB`
}

export async function uploadEditorAsset(file, bizType = 'cms', options = {}) {
  const { maxSize, validateType } = options
  if (!file) {
    throw new Error('未选择文件')
  }
  if (validateType && !validateType(file)) {
    throw new Error('文件类型不支持')
  }
  if (maxSize && file.size > maxSize) {
    throw new Error(`文件大小不能超过 ${formatFileSize(maxSize)}`)
  }

  const result = await uploadFile(file, bizType, { useAdmin: true })
  const path = normalizeFileUrl(result.url)
  return {
    path,
    url: resolveFileUrl(path),
    fileName: result.fileName || file.name
  }
}

export function escapeHtml(text) {
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}
